<template>
  <transition appear>
    <div class="hello">
      <img src="../assets/puffindev.png">

      <h1>Welcome to your dashboard!</h1>

      <h2>Start managing your marketing activities</h2>

      <div class="g-signin2" data-onsuccess="onSignIn"></div>

      <div class="tip">
        <p>
          <i class="el-icon-info"></i>
          <a href="https://drive.google.com/file/d/1D4ULgn2XKCiUJiiZMUY-VC2voiAxYoNg/view" target="_blank">Read the guidelines</a>
        </p>
      </div>

      <router-link to="/marketing/premium" class="folder folder--premium">
        Premium
      </router-link>

      <router-link to="/marketing/tips" class="folder folder--tips">
        Tips of the day
      </router-link>
      <!--<router-link to="/marketing/help" class="folder folder--help">
        Contextual help
      </router-link>-->
    </div>
  </transition>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  data() {
    return {
      value1: null,
      value2: null,
      show: false,
    };
  },
  mounted() { },
  methods: {
    handleLogin() {
      axios({ method: 'GET', url: 'http://127.0.0.1:10010/auth/google' })
      .then((result) => {
        console.log('result:', result);
      }, (error) => {
        console.error(error);
      });

      // window.location = 'https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.metadata.readonly&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=http%3A%2F%2Flocalhost%3A8080&response_type=token&client_id=290692198781-2kibalbenl4ulk9m1jvcdhvm7d69ja6h.apps.googleusercontent.com';
      /*
      window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
          client_id: 'YOUR-CLIENT-ID-HERE.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
        });
        auth2.attachClickHandler(this.$refs.signinBtn, {}, (googleUser) => {
          this.$emit('done', googleUser);
        }, error => console.log(error));
      });
      */
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<style lang="sass" scoped>
  @import '../sass/variables'
  .folder
    background-color: #fff
    border-radius: 5px
    color: #3e3e3e
    cursor: pointer
    display: inline-block
    font-weight: 500
    height: 55px
    line-height: 55px
    margin-right: 30px
    padding-left: 20px
    text-align: left
    text-decoration: none
    transition: all .3s ease
    width: 135px
    border-top: 1px solid #eee
    border-bottom: 1px solid #eee
    border-right: 1px solid #eee

    &:hover
      -webkit-box-shadow: $zDepth2
      box-shadow: $zDepth2

    &:last-of-type
      margin-right: 0px

    &--premium
      border-left: 3px solid #ffc16a

    &--tips
      border-left: 3px solid #00c3ff

    &--help
      border-left: 3px solid #a98efe

  .tip
    padding: 8px 16px
    background-color: #f2fff2
    border-radius: 4px
    margin: 20px 0
    width: 314px
    border-radius: 5px
    margin: auto
    margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue